module.exports = __webpack_public_path__ + "static/media/007-comet.8eebe4e5.svg";